/// <amd-module name="Test/TestPlansHubRefresh/TestCasesClonePanel/Redux/TestCasesClonePanelReducer" />
import { default as produce } from "immer";
import { ITestCasesClonePanelState } from "./TestCasesClonePanelContracts";
import { TestCasesClonePanelActions, TestCasesClonePanelActionsType } from "./TestCasesClonePanelActions";

export function TestCasesClonePanelReducer(state: ITestCasesClonePanelState, action: TestCasesClonePanelActions) {
    state = state || ({} as ITestCasesClonePanelState);

    return produce(state, (draftState: ITestCasesClonePanelState) => {
        switch (action.type) {
            case TestCasesClonePanelActionsType.copyTestCasesInProgress:
                draftState.cloneInProgress = true;
                break;
            case TestCasesClonePanelActionsType.copyTestCasesCompleted:
                draftState.cloneInProgress = false;
                draftState.opId = action.payload.opId;
                break;
            case TestCasesClonePanelActionsType.projectsFetchSucceeded:
                draftState.projectList = action.payload;
                break;
            case TestCasesClonePanelActionsType.testPlansFetchSucceeded:
                draftState.testPlanList = action.payload.planList;
                draftState.testPlanListProject = action.payload.project;
                break;
            case TestCasesClonePanelActionsType.getTestSuitesForPlanSucceeded:
                draftState.suiteList = action.payload;
                break;
            case TestCasesClonePanelActionsType.mandatoryFieldUpdated:
                draftState.mandatoryFieldUpdated = action.payload;
                break;
            case TestCasesClonePanelActionsType.testCasesClonePanelError:
                draftState.testPlanSelectionErrorMessage = action.payload.testPlanSelectionErrorMessage;
                break;
            case TestCasesClonePanelActionsType.testCasesClonePanelSuiteSelectionError:
                draftState.testSuiteSelectionErrorMessage = action.payload.testSuiteSelectionErrorMessage;
                break;
            case TestCasesClonePanelActionsType.disableTestSuiteEditableDropdownSelection:
                draftState.disableTestSuiteDropdown = action.payload;
                break;
        }
    });
}
